import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { style: {"overflow-y":"auto","overflow-x":"hidden","max-height":"50vh"} }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_8 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_9 = {
  key: 2,
  class: "mb-1"
}
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { class: "mb-1" }
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = { class: "mb-1" }
const _hoisted_21 = { class: "mb-1" }
const _hoisted_22 = { class: "mb-1" }
const _hoisted_23 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_24 = {
  key: 1,
  class: "mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header" }, "Résumé des informations", -1)),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              outlined: "",
              class: "card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pt-1 pb-2" }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" Type d'offre choisi: ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pb-1" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.offerType), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "pb-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                outlined: "",
                class: "card pb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "pt-1 pb-2" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode(" Informations personnelles: ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_3, "Nom: " + _toDisplayString(_ctx.data.user.lastname), 1),
                      _createElementVNode("p", _hoisted_4, "Prenom: " + _toDisplayString(_ctx.data.user.name), 1),
                      _createElementVNode("p", _hoisted_5, "Email: " + _toDisplayString(_ctx.data.user.email), 1),
                      _createElementVNode("p", _hoisted_6, "Numéro de téléphone: " + _toDisplayString(_ctx.data.user.phoneNumber), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "pb-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                outlined: "",
                class: "card pb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "pt-1 pb-2" }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode(" Informations de l'entreprise: ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      (_ctx.data.company.name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Nom de l'entreprise: " + _toDisplayString(_ctx.data.company.name), 1))
                        : _createCommentVNode("", true),
                      (_ctx.data.company.legalUnitName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Nom légale: " + _toDisplayString(_ctx.data.company.legalUnitName), 1))
                        : _createCommentVNode("", true),
                      (_ctx.data.company.tradeName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Nom commercial: " + _toDisplayString(_ctx.data.company.tradeName), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_10, "Siret: " + _toDisplayString(_ctx.data.company.siret), 1),
                      _createElementVNode("p", _hoisted_11, "Siren: " + _toDisplayString(_ctx.data.company.siren), 1),
                      _createElementVNode("p", _hoisted_12, "Numéro de TVA: " + _toDisplayString(_ctx.data.company.vatNumber), 1),
                      _createElementVNode("p", _hoisted_13, " Adresse: " + _toDisplayString(_ctx.data.company.address) + " " + _toDisplayString(_ctx.data.company.city) + ", " + _toDisplayString(_ctx.data.company.postalCode) + " " + _toDisplayString(_ctx.data.company.country), 1),
                      (_ctx.data.company.legalForm)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t("settings.legalForm")) + ": " + _toDisplayString(_ctx.data.company.legalForm), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "pb-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                outlined: "",
                class: "card pb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "pt-1 pb-2" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" Informations comptables: ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_15, "Catégorie de revenu: " + _toDisplayString(_ctx.incomeCategory), 1),
                      _createElementVNode("p", _hoisted_16, "Régime fiscal: " + _toDisplayString(_ctx.taxRegime), 1),
                      _createElementVNode("p", _hoisted_17, "Type de comptabilité: " + _toDisplayString(_ctx.accountingType), 1),
                      _createElementVNode("p", _hoisted_18, " Êtes-vous assujetti à la TVA: " + _toDisplayString(_ctx.data.accounting.payedVAT ? "oui" : "non"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "pb-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                outlined: "",
                class: "card pb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "pt-1 pb-2" }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" Informations déclaratives: ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_19, "Régime TVA: " + _toDisplayString(_ctx.vatSystems), 1),
                      _createElementVNode("p", _hoisted_20, " Jour déclaration TVA: " + _toDisplayString(_ctx.data.declaration.vatDeclarationDay), 1),
                      _createElementVNode("p", _hoisted_21, "Option de TVA: " + _toDisplayString(_ctx.vatOptions), 1),
                      _createElementVNode("p", _hoisted_22, "Imposition: " + _toDisplayString(_ctx.taxSystemTypes), 1),
                      (_ctx.data.declaration.startBusinessDate)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Date de début d'activité: " + _toDisplayString(_ctx.startDate), 1))
                        : _createCommentVNode("", true),
                      (_ctx.data.declaration.firstAccountingPeriodEnd)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Date de fin du premier exercice: " + _toDisplayString(_ctx.endDate), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}